module.exports = __webpack_public_path__ + "img/lucky7daily_icon.1cee2cc8.png";